import * as React from 'react';

import { translate } from '~l10n/client';
import { SmallButton } from '~shared/components/buttons';
import { Error as ErrorIcon } from '~teacher/components/ExportReports/ExportFeedback/ExportFeedbackIcons';

import { ExtractQuestionsHeader } from './ExtractQuestionsHeader';

interface ExtractQuestionsErrorProps {
  onRetry: () => void;
}

export function ExtractQuestionsError({ onRetry }: ExtractQuestionsErrorProps) {
  return (
    <>
      <div className="pb-4">
        <ExtractQuestionsHeader />
      </div>
      <div
        className="grid items-center justify-center h-full"
        style={{ boxShadow: '0px 1px 0px 0px #E7EDF0 inset' }}
      >
        <div className="flex flex-col items-center gap-3">
          <ErrorIcon />
          <span className="pt-4 font-display text-md font-500 text-blue-900">
            {translate('Something Went Wrong')}
          </span>
          <span className="max-w-2xl pt-3 font-sans text-base leading-8 text-blue-900 text-center">
            {translate('An unknown error occurred. Please try again later.')}
          </span>
          <SmallButton className="my-1" onClick={onRetry} appearance="primary">
            {translate('Try Again')}
          </SmallButton>
        </div>
      </div>
    </>
  );
}
